var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "Modal2",
        {
          attrs: {
            title: _vm.$t("userInfoWidget.adsYouAreInterestedIn"),
            "show-footer": false,
            "class-name": "forwardRepresentativeModal",
          },
          on: { cancel: _vm.closeModal },
        },
        [
          _c("ve-table", {
            attrs: {
              columns: _vm.getColumns(),
              "table-data": _vm.metaReferrals,
              "row-style-option": _vm.rowStyleOption,
              "border-x": true,
              "border-y": true,
              "row-key-field-name": "_id",
              id: "meta-referrals-table",
              "fixed-header": true,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }